import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { CountryDropdown, RegionDropdown } from "react-country-region-selector";
import { firestore } from "../firebase/config";
import * as AiReactIcon from "react-icons/ai";
import DonorRefList from "./DonorRefList";
import { useSession } from "../firebase/UserProvider";
import { GetUserPrivilages } from "../firebase/UserPrivilageProvider";
import {
  collection,
  addDoc,
  serverTimestamp,
  query,
  where,
  orderBy,
  limit,
  getDocs,
  getDocsFromServer,
} from "firebase/firestore";

function AddANewDonor() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [country, setCountry] = React.useState("");
  const [state, setState] = React.useState("");
  const [donorRefOption, setDonorRefOption] = useState("Self");
  const [donorRefSearchQuery, setDonorRefSearchQuery] = useState(""); //To store the query string of other donor ref
  const [donorRefError, setDonorRefError] = useState(false);
  const [donorRefList, setDonorRefList] = useState(null); //To store the result of donor ref search
  const [donorRef, setDonorRef] = useState("Self"); //Store donor ref's id
  const [panError, setPanError] = useState(false); //pan error for uniquenes
  const [isLoading, setisLoading] = useState(false);
  const history = useHistory();
  const { user } = useSession();

  /**
   *
   * @param {*} donorData
   */
  const addDonorRecord = async (donorData) => {
    //add the new donor

    try {
      const docRef = await addDoc(collection(firestore, "donors"), {
        fullName: donorData.fullName.toUpperCase(),
        pan: donorData.pan.toUpperCase(),
        phone: donorData.phone,
        spiritualName: donorData.spiritualName.toUpperCase(),
        email: donorData.email.toUpperCase(),
        dob: donorData.dob ? new Date(donorData.dob) : "",
        address: {
          addressLine1: donorData.addressLine1.toUpperCase(),
          addressLine2: donorData.addressLine2.toUpperCase(),
          city: donorData.city.toUpperCase(),
          pin: donorData.pin,
          state: state,
          country: country,
        },
        totalCollection: 0,
        totalCommitment: 0,
        totalCommitmentCollection: 0,
        totalDonation: 0,
        reference: donorRef,
        updatedBy: user.email,
        updatedAt: serverTimestamp(),
        createdBy: user.email,
        createdAt: serverTimestamp(),
      });
      alert("The record has been added successfully");

      history.push(`/donordetails/${docRef.id}`);
    } catch (e) {
      console.error("Error adding document: ", e);
      alert("Error in adding the donor record");
    } finally {
      setisLoading(false);
    }
  };
  /*
  
   */
  const addDonorDetails = async (donorData) => {
    /*
    Check if Donor Ref is Other and donorRef ==  null
    if yes then throw error
    else check if there is any record with PAN no
    if yes, then show error saying the donor with provided PAN exists
    else, save the record to database
     */
    setisLoading(true);

    //If donor reference is selected as 'Other' but no referece is selected, then show error
    donorRef === null ? setDonorRefError(true) : setDonorRefError(false);
    try {
      if (donorData.pan !== null || donorData.pan !== "") {
        //Check if the pan provided is unique or not
        let sPan = donorData.pan.toUpperCase();

        // Construct a Firestore query to find documents where the 'pan' field matches the provided PAN.

        const panQuery = query(
          collection(firestore, "donors"),
          where("pan", "==", sPan)
        );
        // Check if a document matching the PAN query exists.
        const querySnapshot = await getDocsFromServer(panQuery);

        if (querySnapshot.empty) {
          // No donor with matching PAN found, proceed with adding new donor

          await addDonorRecord(donorData);
        } else {
          alert("Donor with same PAN exists. Please add an unique PAN");
        }
      } else {
        addDonorRecord(donorData);
      }
    } catch (e) {
      console.log("AddANewDonor addDonorDetails Error: " + e);
      console.log(e);
    } finally {
      setisLoading(false);
    }
  }; //End of addDonorDetails

  /*
   * This function is called from DonorRefList sub components
   * It sets the ref id of the selected reference
   */
  const updateDonorRefValue = (donorRefId, donorRefFullName) => {
    setDonorRef(donorRefId);
    setDonorRefList(null);

    setDonorRefSearchQuery(donorRefFullName);
  };

  /*
  Handles Donor Reference radio button click.
  sets the value of selected option of Donor Reference to 'donorRefOption' state
   */
  const handleCollectedByOptions = (e) => {
    // donorRefList !== null ? setDonorRefList(null) : "";
    if (donorRefList !== null) setDonorRefList(null);
    setDonorRefSearchQuery("");
    e.target.value === "Self" ? setDonorRef("Self") : setDonorRef(null);
    // donorRefError === true ? setDonorRefError(false) : " ";
    setDonorRefOption(e.target.value);

    //If error message is displayed and the Donor Reference option changes, hide the error message
    if (donorRefError) setDonorRefError(false);
  }; //End of handleCollectedByOptions function

  async function handleDonorRefSearch(e) {
    e.preventDefault();
    setDonorRefList(null);
    setDonorRefError(false);

    const searchString = donorRefSearchQuery.toUpperCase();

    const q = query(
      collection(firestore, "donors"),
      where("fullName", ">=", searchString),
      orderBy("fullName"),
      limit(3)
    );

    try {
      const querySnapshot = await getDocs(q);
      const donorRefList = [];
      querySnapshot.forEach((doc) => {
        donorRefList.push({
          donorId: doc.id,
          fullName: doc.data().fullName,
        });
      });
      setDonorRefList(donorRefList);
    } catch (error) {
      console.error("Error fetching donor references:", error);
      // Handle errors appropriately, e.g., set an error flag
    }
  } //end of const handleDonorRefSearch

  /*Function to update the pan error */
  const panChanged = (val) => {
    if (panError) setPanError(false);
  };
  /*
The function returns true if the date passed through value is less than 18 years 
as of today */
  const checkDate = (value) => {
    //If date value is before 18 years, then return true
    if (value === null || value === "") return true;
    let dValue = new Date(value);
    let eighteenYearsAgo = new Date();
    eighteenYearsAgo.setFullYear(eighteenYearsAgo.getFullYear() - 18); //Get date 18 years ago

    if (dValue.getTime() <= eighteenYearsAgo.getTime()) {
      console.log(`Returning true after calculation`);
      return true;
    }
    return false;
  }; //End of checkDate
  const privilages = GetUserPrivilages();

  if (!privilages.canCreateDonor) {
    return (
      <div className="container mt-4">
        <div className="alert alert-danger text-center" role="alert">
          You do not have permission to create a new donor.
        </div>
      </div>
    );
  }

  const formClass = `${isLoading ? "ui form loading" : ""}`;
  return (
    <div style={{ padding: "var(--theme-spacing-xl)", display: "flex", flexDirection: "column", gap: "var(--theme-spacing-xl)" }}>
      <div className="card" style={{ padding: "var(--theme-spacing-lg)" }}>
        <h2 style={{ margin: 0, fontFamily: "var(--theme-font-family-display)", color: "var(--theme-color-primary)", textAlign: "center" }}>
          Add a New Donor
        </h2>
      </div>

      <div className="card" style={{ padding: "var(--theme-spacing-2xl)" }}>
        <form className={formClass} onSubmit={handleSubmit(addDonorDetails)} style={{ display: "flex", flexDirection: "column", gap: "var(--theme-spacing-xl)" }}>
          <div style={{ color: "var(--theme-color-error, #dc3545)", fontWeight: 500, fontSize: "0.9rem" }}>
            Fields marked * are mandatory
          </div>

          {/* Personal Details */}
          <section style={{ display: "flex", flexDirection: "column", gap: "var(--theme-spacing-md)" }}>
            <h4 style={{ margin: 0, color: "var(--theme-color-ink)", borderBottom: "1px solid var(--theme-color-canvas-soft)", paddingBottom: "var(--theme-spacing-sm)" }}>
              Personal Details
            </h4>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: "var(--theme-spacing-lg)" }}>
              <div>
                <label style={{ fontWeight: 600, color: "var(--theme-color-ink)", display: "block", marginBottom: "var(--theme-spacing-xs)" }}>
                  Donor Name:<span style={{ color: "var(--theme-color-error, #dc3545)" }}>*</span>
                </label>
                <input
                  type="text"
                  placeholder="Please enter donor legal name here"
                  className="form-control"
                  id="fullName"
                  name="fullName"
                  {...register("fullName", {
                    required: "Please enter donor name",
                    minLength: {
                      value: 3,
                      message: "Please enter at least 3 characters for name",
                    },
                  })}
                />
                {errors.fullName?.message && (
                  <div style={{ color: "var(--theme-color-error, #dc3545)", fontSize: "0.85rem", marginTop: "var(--theme-spacing-xs)" }}>{errors.fullName?.message}</div>
                )}
              </div>
              <div>
                <label style={{ fontWeight: 600, color: "var(--theme-color-ink)", display: "block", marginBottom: "var(--theme-spacing-xs)" }}>PAN:</label>
                <input
                  placeholder="Please enter PAN in capital letter"
                  type="text"
                  className="form-control"
                  name="pan"
                  {...register("pan", {
                    pattern: {
                      value: /[A-Z]{5}[0-9]{4}[A-Z]{1}/g,
                      message: "Please enter a valid PAN number in capital letters",
                    },
                    maxLength: {
                      value: 10,
                      message: "PAN cannot be more than 10 characters",
                    },
                  })}
                  onChange={(val) => panChanged(val)}
                />
                {errors.pan?.message && (
                  <div style={{ color: "var(--theme-color-error, #dc3545)", fontSize: "0.85rem", marginTop: "var(--theme-spacing-xs)" }}>{errors.pan?.message}</div>
                )}
                {panError && (
                  <div style={{ color: "var(--theme-color-error, #dc3545)", fontSize: "0.85rem", marginTop: "var(--theme-spacing-xs)" }}>
                    The PAN entered is already used. Please use unique PAN or search for the donor.
                  </div>
                )}
              </div>
              <div>
                <label style={{ fontWeight: 600, color: "var(--theme-color-ink)", display: "block", marginBottom: "var(--theme-spacing-xs)" }}>Spiritual Name:</label>
                <input
                  type="text"
                  placeholder="Please enter spiritual name here"
                  className="form-control"
                  id="spiritualName"
                  name="spiritualName"
                  {...register("spiritualName", {
                    pattern: {
                      value: /\D/,
                      message: "Please enter only characters",
                    },
                  })}
                />
                {errors.spiritualName?.message && (
                  <div style={{ color: "var(--theme-color-error, #dc3545)", fontSize: "0.85rem", marginTop: "var(--theme-spacing-xs)" }}>{errors.spiritualName?.message}</div>
                )}
              </div>
              <div>
                <label style={{ fontWeight: 600, color: "var(--theme-color-ink)", display: "block", marginBottom: "var(--theme-spacing-xs)" }}>Date of Birth:</label>
                <input
                  type="date"
                  className="form-control"
                  name="dob"
                  {...register("dob", {
                    validate: { validDate: (value) => checkDate(value) },
                  })}
                />
                {errors.dob?.message && (
                  <div style={{ color: "var(--theme-color-error, #dc3545)", fontSize: "0.85rem", marginTop: "var(--theme-spacing-xs)" }}>{errors.dob?.message}</div>
                )}
                {errors.dob?.type === "validDate" && (
                  <div style={{ color: "var(--theme-color-error, #dc3545)", fontSize: "0.85rem", marginTop: "var(--theme-spacing-xs)" }}>
                    The donor should be at least 18 years old
                  </div>
                )}
              </div>
            </div>
          </section>

          {/* Communication Details */}
          <section style={{ display: "flex", flexDirection: "column", gap: "var(--theme-spacing-md)" }}>
            <h4 style={{ margin: 0, color: "var(--theme-color-ink)", borderBottom: "1px solid var(--theme-color-canvas-soft)", paddingBottom: "var(--theme-spacing-sm)" }}>
              Communication Details
            </h4>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: "var(--theme-spacing-lg)" }}>
              <div>
                <label style={{ fontWeight: 600, color: "var(--theme-color-ink)", display: "block", marginBottom: "var(--theme-spacing-xs)" }}>Email:</label>
                <input
                  placeholder="Please enter email here"
                  type="email"
                  className="form-control"
                  id="email"
                  name="email"
                  {...register("email")}
                />
              </div>
              <div>
                <label style={{ fontWeight: 600, color: "var(--theme-color-ink)", display: "block", marginBottom: "var(--theme-spacing-xs)" }}>Phone:</label>
                <input
                  placeholder="Please enter phone number in 3-3-4 format"
                  type="tel"
                  pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                  className="form-control"
                  name="phone"
                  {...register("phone")}
                />
              </div>
            </div>
          </section>

          {/* Address Details */}
          <section style={{ display: "flex", flexDirection: "column", gap: "var(--theme-spacing-md)" }}>
            <h4 style={{ margin: 0, color: "var(--theme-color-ink)", borderBottom: "1px solid var(--theme-color-canvas-soft)", paddingBottom: "var(--theme-spacing-sm)" }}>
              Address
            </h4>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: "var(--theme-spacing-lg)" }}>
              <div>
                <label style={{ fontWeight: 600, color: "var(--theme-color-ink)", display: "block", marginBottom: "var(--theme-spacing-xs)" }}>
                  Address Line1:<span style={{ color: "var(--theme-color-error, #dc3545)" }}>*</span>
                </label>
                <input
                  placeholder="Please enter address line 1 here"
                  type="text"
                  className="form-control"
                  id="addressLine1"
                  name="addressLine1"
                  {...register("addressLine1", {
                    required: "Please enter address line 1",
                    minLength: {
                      value: 4,
                      message: "The address line 1 should have at least 4 characters",
                    },
                  })}
                />
                {errors.addressLine1?.message && (
                  <div style={{ color: "var(--theme-color-error, #dc3545)", fontSize: "0.85rem", marginTop: "var(--theme-spacing-xs)" }}>{errors.addressLine1?.message}</div>
                )}
              </div>
              <div>
                <label style={{ fontWeight: 600, color: "var(--theme-color-ink)", display: "block", marginBottom: "var(--theme-spacing-xs)" }}>Address Line2:</label>
                <input
                  placeholder="Please enter address line 2 here"
                  type="text"
                  className="form-control"
                  name="addressLine2"
                  {...register("addressLine2", {})}
                />
                {errors.addressLine2?.message && (
                  <div style={{ color: "var(--theme-color-error, #dc3545)", fontSize: "0.85rem", marginTop: "var(--theme-spacing-xs)" }}>{errors.addressLine2?.message}</div>
                )}
              </div>
              <div>
                <label style={{ fontWeight: 600, color: "var(--theme-color-ink)", display: "block", marginBottom: "var(--theme-spacing-xs)" }}>
                  City:<span style={{ color: "var(--theme-color-error, #dc3545)" }}>*</span>
                </label>
                <input
                  placeholder="Please enter city here"
                  type="text"
                  className="form-control"
                  id="city"
                  name="city"
                  {...register("city", {
                    required: "Please enter city",
                  })}
                />
                {errors.city?.message && (
                  <div style={{ color: "var(--theme-color-error, #dc3545)", fontSize: "0.85rem", marginTop: "var(--theme-spacing-xs)" }}>{errors.city?.message}</div>
                )}
              </div>
              <div>
                <label style={{ fontWeight: 600, color: "var(--theme-color-ink)", display: "block", marginBottom: "var(--theme-spacing-xs)" }}>
                  Pin Code:<span style={{ color: "var(--theme-color-error, #dc3545)" }}>*</span>
                </label>
                <input
                  placeholder="Please enter pin code here"
                  type="number"
                  className="form-control"
                  name="pin"
                  {...register("pin", {
                    required: "Please enter Pin code",
                    minLength: {
                      value: 6,
                      message: "Pin code should be at least 6 digits",
                    },
                    maxLength: {
                      value: 6,
                      message: "Pin code should not be more than 6 digits",
                    },
                  })}
                />
                {errors.pin?.message && (
                  <div style={{ color: "var(--theme-color-error, #dc3545)", fontSize: "0.85rem", marginTop: "var(--theme-spacing-xs)" }}>{errors.pin?.message}</div>
                )}
              </div>
              <div>
                <label style={{ fontWeight: 600, color: "var(--theme-color-ink)", display: "block", marginBottom: "var(--theme-spacing-xs)" }}>
                  Country:<span style={{ color: "var(--theme-color-error, #dc3545)" }}>*</span>
                </label>
                <CountryDropdown
                  defaultOptionLabel="Select a country"
                  value={country}
                  required
                  onChange={(val) => setCountry(val)}
                  className="form-control"
                />
              </div>
              <div>
                <label style={{ fontWeight: 600, color: "var(--theme-color-ink)", display: "block", marginBottom: "var(--theme-spacing-xs)" }}>
                  State:<span style={{ color: "var(--theme-color-error, #dc3545)" }}>*</span>
                </label>
                <RegionDropdown
                  country={country}
                  required
                  blankOptionLabel="No country selected"
                  defaultOptionLabel="Now select a state/region"
                  value={state}
                  onChange={(val) => setState(val)}
                  className="form-control"
                />
              </div>
            </div>
          </section>

          {/* Donor Reference */}
          <section style={{ display: "flex", flexDirection: "column", gap: "var(--theme-spacing-md)" }}>
            <h4 style={{ margin: 0, color: "var(--theme-color-ink)", borderBottom: "1px solid var(--theme-color-canvas-soft)", paddingBottom: "var(--theme-spacing-sm)" }}>
              Donor Reference
            </h4>
            <div style={{ display: "flex", flexDirection: "column", gap: "var(--theme-spacing-md)" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "var(--theme-spacing-lg)" }}>
                <label style={{ fontWeight: 600, color: "var(--theme-color-ink)", display: "flex", alignItems: "center", gap: "var(--theme-spacing-xs)" }}>
                  <input
                    type="radio"
                    id="selfDonor"
                    name="collectedBy"
                    value="Self"
                    checked={donorRefOption === "Self"}
                    onChange={handleCollectedByOptions}
                  />
                  Self
                </label>
                <label style={{ fontWeight: 600, color: "var(--theme-color-ink)", display: "flex", alignItems: "center", gap: "var(--theme-spacing-xs)" }}>
                  <input
                    type="radio"
                    id="otherDonor"
                    name="collectedBy"
                    value="otherDonor"
                    checked={donorRefOption === "otherDonor"}
                    onChange={handleCollectedByOptions}
                  />
                  Other
                </label>
              </div>

              {donorRefOption === "otherDonor" && (
                <div style={{ padding: "var(--theme-spacing-md)", backgroundColor: "var(--theme-color-canvas-soft)", borderRadius: "var(--theme-rounded-md)" }}>
                  <label style={{ fontWeight: 500, color: "var(--theme-color-body)", display: "block", marginBottom: "var(--theme-spacing-sm)" }}>
                    {donorRef == null
                      ? `If donor reference is "Other", please search below.`
                      : `Donor reference selected successfully.`}
                  </label>
                  <div className="input-group">
                    <input
                      placeholder="Search Name..."
                      className="form-control"
                      name="searchRef"
                      value={donorRefSearchQuery}
                      onChange={(e) => setDonorRefSearchQuery(e.target.value)}
                    />
                    <button
                      className="btn btn-outline-secondary"
                      type="button"
                      onClick={handleDonorRefSearch}
                    >
                      <AiReactIcon.AiOutlineSearch />
                    </button>
                  </div>
                  
                  {donorRefList && (
                    <div style={{ marginTop: "var(--theme-spacing-md)" }}>
                      <DonorRefList
                        queryList={donorRefList}
                        updateDonorRefValue={updateDonorRefValue}
                      />
                    </div>
                  )}
                </div>
              )}
              {donorRefError && (
                <div style={{ color: "var(--theme-color-error, #dc3545)", fontSize: "0.85rem" }}>
                  Please select a reference for the donor
                </div>
              )}
            </div>
          </section>

          {/* Form Actions */}
          <div style={{ display: "flex", justifyContent: "center", gap: "var(--theme-spacing-md)", marginTop: "var(--theme-spacing-md)", paddingTop: "var(--theme-spacing-lg)", borderTop: "1px solid var(--theme-color-canvas-soft)" }}>
            <button type="submit" className="btn btn-primary" style={{ padding: "var(--theme-spacing-sm) var(--theme-spacing-xl)" }}>
              Save
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              style={{ padding: "var(--theme-spacing-sm) var(--theme-spacing-xl)" }}
              onClick={(e) => {
                e.preventDefault();
                history.push(`/`);
              }}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddANewDonor;
